import { jsx, jsxs } from "react/jsx-runtime";
import List from "@mui/material/List/index.js";
import ListItemButton from "@mui/material/ListItemButton/index.js";
import { useLabels } from "../../providers/labels.provider.js";
import { ActionsPopover, ActionMenuListItemText } from "./InvoiceActionsPopover.styles.js";
import "react";
import "@mui/material/Popover/index.js";
import "@mui/material/styles";
import "@mui/material/Typography/index.js";
const InvoiceActionsPopover = ({
  isOpen,
  anchorEl,
  onClose,
  onRemoveActionClick,
  onOpenTreatmentSheetActionClick,
  onOpenInvoiceActionClick
}) => {
  const { labels } = useLabels();
  return /* @__PURE__ */ jsx(
    ActionsPopover,
    {
      open: isOpen,
      anchorEl,
      onClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      children: /* @__PURE__ */ jsxs(List, { children: [
        onRemoveActionClick && /* @__PURE__ */ jsx(ListItemButton, { onClick: onRemoveActionClick, children: /* @__PURE__ */ jsx(ActionMenuListItemText, { variant: "Lato Body 1", children: labels.actionMenu.deleteFromList }) }),
        onOpenTreatmentSheetActionClick && /* @__PURE__ */ jsx(ListItemButton, { onClick: onOpenTreatmentSheetActionClick, children: /* @__PURE__ */ jsx(ActionMenuListItemText, { variant: "Lato Body 1", children: labels.actionMenu.openTreatmentSheet }) }),
        onOpenInvoiceActionClick && /* @__PURE__ */ jsx(ListItemButton, { onClick: onOpenInvoiceActionClick, children: /* @__PURE__ */ jsx(ActionMenuListItemText, { variant: "Lato Body 1", children: labels.actionMenu.openInvoice }) })
      ] })
    }
  );
};
export {
  InvoiceActionsPopover as default
};
